import { render, staticRenderFns } from "./CookiesPage.vue?vue&type=template&id=288cdabb&scoped=true"
import script from "./CookiesPage.vue?vue&type=script&lang=js"
export * from "./CookiesPage.vue?vue&type=script&lang=js"
import style0 from "./CookiesPage.vue?vue&type=style&index=0&id=288cdabb&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "288cdabb",
  null
  
)

export default component.exports